/**
 * Category filter tabs for the "Angebote Übersicht" layout
 * (template-parts/angebote-uebersicht.php). Same accessible tablist pattern
 * as the "Tabs" layout (js/tabs-element.js: WAI-ARIA Tabs, manual
 * activation, arrow/Home/End move focus, Enter/Space or click activates) -
 * but there's only one shared list of offers here, not a separate panel
 * per tab, so "activating" a tab filters which .angeboteUebersichtItem
 * elements are visible instead of swapping panel content. Items are hidden
 * via the native `hidden` attribute, same as elsewhere this session, so
 * they're correctly removed from the accessibility tree/tab order too.
 */

function lhmAngeboteMoveFocus(tabs, index) {
    tabs.forEach((tab, i) => {
        tab.setAttribute('tabindex', i === index ? '0' : '-1');
    });
    tabs[index].focus();
}

function lhmAngeboteFilterList(list, categoryId) {
    const items = list.querySelectorAll('.angeboteUebersichtItem');

    items.forEach((item) => {
        if (!categoryId) {
            item.hidden = false;
            return;
        }

        const categories = (item.getAttribute('data-categories') || '').split(',').filter(Boolean);
        item.hidden = !categories.includes(categoryId);
    });
}

function lhmAngeboteActivateTab(tabs, tablist, index) {
    tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });

    const list = document.getElementById(tablist.getAttribute('data-target'));
    if (list) {
        lhmAngeboteFilterList(list, tabs[index].getAttribute('data-category'));
        list.setAttribute('aria-labelledby', tabs[index].id);
    }
}

function lhmInitAngeboteFilter(tablist) {
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    if (tabs.length === 0) {
        return;
    }

    let focusedIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
    if (focusedIndex === -1) {
        focusedIndex = 0;
    }

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            focusedIndex = index;
            lhmAngeboteMoveFocus(tabs, focusedIndex);
            lhmAngeboteActivateTab(tabs, tablist, focusedIndex);
        });

        tab.addEventListener('keydown', (event) => {
            switch (event.key) {
                case 'ArrowRight':
                case 'ArrowDown':
                    event.preventDefault();
                    focusedIndex = (index + 1) % tabs.length;
                    lhmAngeboteMoveFocus(tabs, focusedIndex);
                    break;
                case 'ArrowLeft':
                case 'ArrowUp':
                    event.preventDefault();
                    focusedIndex = (index - 1 + tabs.length) % tabs.length;
                    lhmAngeboteMoveFocus(tabs, focusedIndex);
                    break;
                case 'Home':
                    event.preventDefault();
                    focusedIndex = 0;
                    lhmAngeboteMoveFocus(tabs, focusedIndex);
                    break;
                case 'End':
                    event.preventDefault();
                    focusedIndex = tabs.length - 1;
                    lhmAngeboteMoveFocus(tabs, focusedIndex);
                    break;
                case 'Enter':
                case ' ':
                case 'Spacebar':
                    event.preventDefault();
                    lhmAngeboteActivateTab(tabs, tablist, index);
                    break;
                default:
                    break;
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.angeboteFilterTablist').forEach(lhmInitAngeboteFilter);
});
